import React, { useState } from 'react'
import { ToggleButton } from 'primereact/togglebutton'
import { useDispatch } from 'react-redux'
import { Col, Row, Button, Label } from 'reactstrap'
import CustomEditor from '../../common/CustomEditor'
import { closeModal } from '../../common/GlobalModal/redux/GlobalModalActions'
import CustomInput from '../../common/InputGroup'
import { createSharedNote } from '../ClickToCall/Redux/clickToCallActions'
import CustomModal, { useModal } from '../../common/CustomModal/CustomModal'
import { useFileAttachments } from '../../hooks/useFileAttachments'
import { AddAttachment } from '../../common/FileAttachment/AddAttachment'

export default function SharedNoteForm({ contactId }) {
  const [state, setState] = useState({
    subject: '',
    note: '',
    isDivisionOnly: false,
  })
  const [oldCrmNote, setOldCrmNote] = useState('')

  const { attachments, isMaxFilesExceeded, onUploadDocuments: onAttachmentUpload, List } = useFileAttachments()
  const { isModalOpen: isAddAttachmentModalOpen, toggleModal: toggleAddAttachmentModal } = useModal()

  const dispatch = useDispatch()

  const changeHandler = (e) => {
    const { name, value } = e.target
    setState((prev) => ({ ...prev, [name]: value }))
  }

  const editorChangeHandler = (e) => {
    setOldCrmNote(e.textValue)
    setState((prev) => ({ ...prev, ['note']: e.htmlValue }))
  }

  const createCommentHandler = () => {
    dispatch(createSharedNote(contactId, { ...state, oldCrmNote }, attachments))
  }

  const closeModalHandler = () => {
    dispatch(closeModal('shared_notes_modal'))
  }

  const onUploadDocuments = (data) => {
    toggleAddAttachmentModal()
    onAttachmentUpload(data)
  }

  return (
    <>
      <CustomModal
        isOpen={isAddAttachmentModalOpen}
        toggle={toggleAddAttachmentModal}
        headerText={`Add Attachment`}
        big
        showCloseButton
      >
        <AddAttachment multiple onUploadDocuments={onUploadDocuments} />
      </CustomModal>

      <Row>
        <Col>
          <CustomInput
            type={'text'}
            name={'subject'}
            onChange={changeHandler}
            label={'Subject (optional)'}
            value={state.subject}
          />
        </Col>
      </Row>
      <Row className={'mt-5'}>
        <Col xs={12} md={12} lg={12}>
          <CustomEditor
            disabled={isMaxFilesExceeded}
            addAttachmentClick={toggleAddAttachmentModal}
            onChange={editorChangeHandler}
            value={state.note}
            height={'250px'}
            customStyle={{ backgroundColor: 'none' }}
          />
        </Col>
      </Row>
      <Row>
        <Col>{List}</Col>
      </Row>
      <Row className={'mt-3'}>
        <Col className={'d-flex align-items-center'}>
          {/* Off by default: a note stays visible to everyone unless the author says otherwise. */}
          <Label className={'mb-0 mr-2'}>Division only</Label>
          <ToggleButton
            checked={state.isDivisionOnly}
            onChange={() => setState((prev) => ({ ...prev, isDivisionOnly: !prev.isDivisionOnly }))}
          />
        </Col>
        <Col className={'d-flex justify-content-end align-items-center'}>
          <Button className={'btn-gold mr-3'} onClick={createCommentHandler}>
            Ok
          </Button>
          <Button className={'btn-gold'} onClick={closeModalHandler}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  )
}
